/* eslint-disable vue/no-use-v-if-with-v-for */

<template>

  <table-main v-model="tableData"
  :filterColumn="filterColumn" :dataType="dataType"
  :ascending-filter="ascendingFilter" :page-size="pageSize" :pagination="pagination"
  :loading="loading" :maxSize="maxSize"
   :current-page="currentPage" :searchQuery="searchQuery" :getServerData="getServerData"
   :columns="tableColumns" :initialState="state" :topColumns="4" :showChild="showChild">
    <div slot-scope="{ headers, rows, pages}" role="presentation">
      <div>
        <text-input v-if="searchable" class="search-input"  v-model="searchQuery"
        placeholder="Search Table"></text-input>
      </div>
      <div role="group" tabindex="0" :aria-labelledby="captionID" ref='container'>
        <table class=" tableMain">
          <caption :id="captionID">
            {{tableCaption }}
            <small v-if="tabIndex === '0'">(scroll to see more)</small>
           </caption>
          <thead class="tableHead">
            <th scope="col" class="th " v-for="header in headers" :key="header.id"
              :colspan="header.colspan">
              <h4 class="inline-block-child">{{header.value}}</h4>
                <span v-if="filter" class="inline-block-child">
                  <button
                    @click="filterData(header.value, true)"
                    aria-label="Sort by ascending order">
                      <i aria-hidden="true" class="icon-arrow-up2"></i>
                  </button>
                  <button
                    @click="filterData(header.value, false)"
                    aria-label="Sort by descending order">
                    <i aria-hidden="true" class="icon-arrow-down2" ></i>
                  </button>
                </span>
            </th>
          </thead>
          <tbody
            v-if="(dataType === 'clientSide' || (dataType === 'serverSide' && !loading))"
            class="tableBody">
            <tr
              v-on:click="click(d)"
              class="tr"
              :class="applyStyles"
              v-for="(d, dataIndex) in rows" :key="dataIndex"
              v-show="d.isVisible"
              >
                  <td
                    v-for="(c, columnIndex) in tableColumns"
                    :key="columnIndex"
                    :class="isActive(d.id)"
                    :style="applyCellStyle(columnIndex)"
                    >
                        <div class="tableValueMain">{{d[c || c.value]}}</div>
                        <div v-if="showChild===d.id"
                        class="tableExtra"><p>adfadf</p> <p>man</p>
                        </div>
                  </td>
            </tr>

          </tbody>
          <div v-else>
            <h1>LOADING DATA</h1>
          </div>
        </table>

      </div>

    <table-pagination
      @updatePage="updatePage"
      v-if="pagination"
      :show-navigation="true"
      :activePage="currentPage"
      :pages="pages">
    </table-pagination>

    </div>
  </table-main>
</template>

<script>
import { TextInput } from '../../../main';
import theme from '../../../mixins/theme';
import TableMain from '../Main';
import TablePagination from './TablePagination.vue';

export default {
  mixins: [theme],
  name: 'TablesMain',
  props: {
    tableColumns: {
      type: Array,
      required: true,
    },
    tableData: {
      type: Array,
      required: true,
    },
    tableCaption: {
      type: String,
      require: true,
    },
    pageSize: {
      type: Number,
    },
    pagination: {
      type: Boolean,
    },
    filter: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
    },
    shouldHover: {
      type: Boolean,
      default: false,
    },
    handleClick: {
      type: Function,
    },
    // Format of this is
    // [{column:1, style: "color:red; background: pink }]
    cellStyles: {
      type: Array,
    },
    showChild: {
      type: [Boolean, Number],
      default: false,
    },
    dataType: {
      default: 'clientSide',
      validator(value) {
        return ['serverSide', 'clientSide'].indexOf(value) !== -1;
      },
    },
    loading: {
      type: Boolean,
      default: true,
    },
    maxSize: {
      type: Number,
      default: 0,
    },
    /**
     * This returns the data from a server
     */
    getServerData: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      updatedRows: [],
      filterObject: {},
      filterColumn: '',
      ascendingFilter: true,
      searchQuery: '',
      state: {
        page: 1,
      },
      captionID: '',
      tabIndex: null,
    };
  },
  components: {
    TableMain,
    TablePagination,
    TextInput,
  },
  mounted() {
    // we need to generate a unique caption ID. arialabelledBy expects a unique ID as it's value.
    // This random value is particularly useful for places where we are using more than one of the
    // table's instance on a webpage. This way, we maintain uniqueness of the ID supplied to
    // arialebelledBy. As a side note, this can be optimized using refs. That way, we can have the
    // value for multiple rerenders instead of recalculating it which I feel is expensive.
    this.captionID = `caption-${Math.random().toString(36).substr(2, 9)}`;

    // For this, we want to set the tabIndex to 0 when it's scrollable horzontally.
    // we don't want to make the table container focusable unless its contents overflow.
    // Otherwise we're adding a tab stop to the focus order which doesn't do anything.
    const { scrollWidth, clientWidth } = this.$refs.container.clientWidth;
    const scrollable = scrollWidth > clientWidth;
    this.tabIndex = scrollable ? 0 : null;
  },
  computed: {
    applyStyles() {
      if (this.shouldHover) {
        return 'hover';
      }
      return '';
    },
  },
  methods: {
    updatePage(page) {
      this.searchQuery = '';
      this.currentPage = page;
      if (this.dataType === 'serverSide') {
        this.$emit('updatePage', page);
      }
    },
    filterData(value, ascending) {
      this.filterColumn = value;
      this.ascendingFilter = ascending;
    },
    applyCellStyle(columnIndex) {
      let style = '';
      if (this.cellStyles) {
        this.cellStyles.forEach((_styles) => {
          if (_styles.column === columnIndex + 1) {
            ({ style } = _styles);
          }
        });
      }
      return style;
    },
    isActive(id) {
      if (id === this.showChild) {
        return 'active';
      }
      return '';
    },
    click(d) {
      this.handleClick(d);
    },
  },
};
</script>
<style lang="scss" scoped>
  @import './tables-main.scss';
</style>
